import { Skeleton, Typography } from '@mui/material'
import BestTrackFocusHover from './BestTrackFocusHover';


interface BestTrackFocusProps {
    discoverData: any
}

const BestTrackFocus = ({ discoverData }: BestTrackFocusProps) => {
    return discoverData 
    ? 
        discoverData.rankings.length > 0
        ? 
            <BestTrackFocusHover rankings={[...discoverData.rankings].sort((a: any, b: any) => 
                b.position_gain.replace('=', '-1').replace('new', '0').replace('+', '') - a.position_gain.replace('=', '-1').replace('new', '0').replace('+', ''))} />
        : 
            <Typography alignSelf={'center'}>Pas de mouvement</Typography>
    :
        <Skeleton variant="rectangular" width={'100%'} height={'55%'} sx={{bgcolor: '#00000068'}}/>

}

export default BestTrackFocus